import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import AccountRemoveRequest from './AccountRemoveRequest';

loadDOMComponent({
	selector: 'react-account-remove',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AccountRemoveRequest />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
